import { CarePlanActivityCode } from '@quromedical/fhir-common';
import { z } from 'zod';
import { DisplayReferenceSchema } from '../domain';
import { UUIDSchema } from '../domain/models';

export const PrioritySchema = z.enum(['routine', 'urgent', 'asap', 'stat']);

export const CarePlanActivityCodeSchema = z.nativeEnum(CarePlanActivityCode);

const ServiceRequestStatusSchema = z.enum([
  'draft',
  'active',
  'on-hold',
  'revoked',
  'completed',
  'entered-in-error',
  'unknown',
]);

const ServiceRequestIntentSchema = z.enum([
  'proposal',
  'plan',
  'order',
  'option',
]);

export const BaseServiceRequestSchema = z.object({
  id: UUIDSchema,
  status: ServiceRequestStatusSchema,
  intent: ServiceRequestIntentSchema,
  category: CarePlanActivityCodeSchema,
  priority: PrioritySchema,
  subject: DisplayReferenceSchema,
  encounter: DisplayReferenceSchema,
  requester: DisplayReferenceSchema,
  performer: DisplayReferenceSchema,
  note: z.array(z.string()),
  occurrenceDateTime: z.string(),
  basedOn: z.array(DisplayReferenceSchema),
});

export type ServiceRequest = z.infer<typeof BaseServiceRequestSchema>;
export type ServiceRequestPriority = z.infer<typeof PrioritySchema>;
